import { useLanguage } from '../contexts/LanguageContext';
import { Phone, Code, Rocket } from 'lucide-react';

const stepIcons = [Phone, Code, Rocket];

export const HowItWorksSection = () => {
  const { t, isRTL } = useLanguage();
  const steps = t('howItWorks.steps');

  return (
    <section id="how-it-works" className="py-12 sm:py-16 md:py-32 bg-background" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-primary">
            {t('howItWorks.title')}
          </h2>
        </div>

        <div className={`grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 relative ${isRTL ? 'md:flex-row-reverse' : ''}`}>
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-20 left-1/6 right-1/6 h-0.5 border-t-2 border-dashed border-slate-200" />

          {Array.isArray(steps) && steps.map((step, index) => {
            const Icon = stepIcons[index];
            return (
              <div 
                key={index} 
                className="relative bg-white rounded-2xl p-5 sm:p-6 md:p-8 text-center shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300"
                data-testid={`step-${index}`}
              >
                {/* Step Number */}
                <div className="absolute -top-3 sm:-top-4 left-1/2 transform -translate-x-1/2 w-6 h-6 sm:w-8 sm:h-8 bg-brand text-white rounded-full flex items-center justify-center font-bold text-xs sm:text-sm">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-brand/10 rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-brand" />
                </div>

                <h3 className="text-lg sm:text-xl font-semibold text-primary mb-2 sm:mb-3">
                  {step.title}
                </h3>
                <p className="text-sm sm:text-base text-slate-600">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
